module.exports = __webpack_public_path__ + "img/rec.01bc7ce5.png";